import type { Comment as CommentType } from '@/@types/comment'
import { Post } from '@/@types/post'
import { modals } from '@mantine/modals'
import PostCard from '../Post/PostCard'
import CommentForm from './CommentForm'
import CommentThread from './CommentThread'
import styles from './utils.module.css'
import type { ReplyToComment } from './schema'

export interface CommentFormModalProps {
	allowSyncToPersonalUpdate?: boolean
	onSubmit?: (comment: CommentType) => void
	replyToComment?: ReplyToComment | null
	replyToPost?: Post | null
}

export function showCommentFormModal(
	options?: CommentFormModalProps & Parameters<typeof modals.open>[0]
) {
	const {
		allowSyncToPersonalUpdate,
		onSubmit,
		replyToComment,
		replyToPost: post,
		onClose,
		...rest
	} = options ?? {}
	const comment = replyToComment?.to

	const targetId = post?.id ?? comment?.targetId
	const targetType = post?.type ?? comment?.targetType

	return modals.open({
		title: '回复',
		children: (
			<div className={styles.modalContent}>
				{post && <PostCard data={post} className={styles.postCard} />}

				{comment && <CommentThread data={comment} showThreadLine noSuffixTitle />}

				{targetId && targetType && (
					<CommentForm
						autoFocus
						allowSyncToPersonalUpdate={allowSyncToPersonalUpdate}
						targetId={targetId}
						targetType={targetType}
						replyToComment={replyToComment}
						onSubmit={(newComment) => {
							onClose?.()
							onSubmit?.(newComment)
						}}
					/>
				)}
			</div>
		),
		onClose,
		...rest,
	})
}
